// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","696":"component---src-pages-hello-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"31aff52a80345ebdc597","696":"093e952814a1cf227e3f","883":"f5d15e81247ce7569ae2"}[chunkId] + ".js";
};